<template>
  <el-table-column
    prop="customer.last_name"
    sortable="custom"
    label="Átvevő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer.last_name',
};
</script>
